module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "join-modal-template"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper join-modal"
  }, [_c('div', {
    staticClass: "modal-container md-modal-container"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [((this.paramStr !== 'reJoin')) ? _c('h2', {
    staticClass: "show-title"
  }, [_vm._v("커뮤니티 가입신청")]) : _vm._e(), _vm._v(" "), ((this.paramStr === 'reJoin')) ? _c('h2', {
    staticClass: "show-title"
  }, [_vm._v("커뮤니티 가입 재신청")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered text-center table-system-authority-roles"
  }, [_c('caption', [_vm._v("커뮤니티 가입 신청자 정보")]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("구성원정보")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("이       름 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input__text",
    staticStyle: {
      "text-align": "left",
      "width": "48%"
    },
    attrs: {
      "type": "text",
      "placeholder": "이름을 입력해 주세요.",
      "title": "이름을 입력해 주세요."
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("전화번호 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone1),
      expression: "phone1"
    }],
    staticClass: "input__text",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "type": "text",
      "placeholder": "전화번호1",
      "title": "전화번호1"
    },
    domProps: {
      "value": (_vm.phone1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone1 = $event.target.value
      }
    }
  }), _vm._v("-\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone2),
      expression: "phone2"
    }],
    staticClass: "input__text",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "type": "text",
      "placeholder": "전화번호2",
      "title": "전화번호2"
    },
    domProps: {
      "value": (_vm.phone2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone2 = $event.target.value
      }
    }
  }), _vm._v("-\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone3),
      expression: "phone3"
    }],
    staticClass: "input__text",
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "type": "text",
      "placeholder": "전화번호3",
      "title": "전화번호3"
    },
    domProps: {
      "value": (_vm.phone3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone3 = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr'), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left",
      "font-weight": "bold"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("커뮤니티 신청 메세지")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "100%",
      "height": "200px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reason),
      expression: "reason"
    }],
    staticClass: "input__textarea input__textarea--thin",
    staticStyle: {
      "width": "98%",
      "height": "98%"
    },
    attrs: {
      "rows": "2",
      "title": "결과 입력"
    },
    domProps: {
      "value": (_vm.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "attendance-action"
  }, [_c('button', {
    staticClass: "sm-btn btn--blue-line",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")]), _vm._v(" "), _c('button', {
    staticClass: "sm-btn btn--blue-line",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15669a67"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/community/MemberJoinButton.vue
// module id = 1303
// module chunks = 6